import { Save, X } from "lucide-react";
import userApi from "../../../../api/userApi";
import { useEffect, useState } from "react";
import { useNotification } from "../../../../hooks/useNotification";

export default function AddViewMoreStaffContact({
  isOpen,
  setIsOpen,
  shop,
  editingStaff,
  staffs,
  getStaffs,
}) {
  const { addNotification } = useNotification();
  const [tempStaff, setTempStaff] = useState([]);

  const handleStaffChange = (e, id) => {
    if (e.target.checked) {
      setTempStaff({
        ...tempStaff,
        shopRoles: tempStaff.shopRoles?.map((sr) =>
          sr.shopId === shop._id
            ? {
                ...sr,
                viewMoreStaffIds: sr.viewMoreStaffIds?.includes(id)
                  ? sr.viewMoreStaffIds
                  : [...(sr.viewMoreStaffIds ?? []), id],
              }
            : sr
        ),
      });
    } else {
      setTempStaff({
        ...tempStaff,
        shopRoles: tempStaff.shopRoles?.map((sr) =>
          sr.shopId === shop._id
            ? {
                ...sr,
                viewMoreStaffIds: sr.viewMoreStaffIds?.includes(id)
                  ? sr.viewMoreStaffIds?.filter((staffId) => staffId !== id)
                  : sr.viewMoreStaffIds,
              }
            : sr
        ),
      });
    }
  };

  const handleCloseClick = () => {
    setIsOpen(false);
  };

  const handleSaveClick = async () => {
    const res = await userApi.updateById({
      _id: tempStaff._id,
      shopRoles: tempStaff.shopRoles,
    });
    if (res.status === 1) addNotification("Lưu thành công", res.status);
    else addNotification(res.message, res.status);
    await getStaffs();
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) setTempStaff(editingStaff);
  }, [isOpen]);

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-medium text-gray-900">
                Xem thêm dữ liệu của nhân viên
              </h3>
              <button
                onClick={handleCloseClick}
                className="text-gray-400 hover:text-gray-500 transition-colors duration-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4">
              <div className="space-y-6">
                <div>
                  {/* Staff Selection */}
                  <div>
                    <p className="mb-2 font-medium">Chọn nhân viên</p>
                    <div className="border rounded-lg p-2 h-60 overflow-y-auto">
                      {staffs
                        .filter((x) => x._id !== tempStaff?._id)
                        .map((staff) => (
                          <label
                            key={staff._id}
                            className="block p-2 hover:bg-gray-50"
                          >
                            <input
                              type="checkbox"
                              checked={
                                tempStaff?.shopRoles
                                  ?.find((sr) => sr.shopId === shop._id)
                                  ?.viewMoreStaffIds?.includes(staff._id)
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleStaffChange(e, staff._id)}
                              className="w-4 h-4"
                            />
                            <span className="ml-2">{staff.name}</span>
                          </label>
                        ))}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="flex justify-end">
                  <button
                    className="inline-flex items-center gap-2 rounded-md bg-green-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 transition-colors duration-200"
                    onClick={handleSaveClick}
                  >
                    <Save className="h-4 w-4" />
                    Lưu
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
